'use client'

import { useEffect, useState } from 'react';
import styled from "styled-components";

const RadioBtnWrap = styled.ul`
    display: flex;
    align-items: center;
    li {
        display: flex;
        align-items: center;
        &:first-child {
            margin-right: 20px;
        }
        label {
            font-size: 16px;
            color: #3b3b3b;
            font-weight: 400;
            margin-left: 10px;
        }
        input[type="radio"] {
            accent-color: red;
        }
    }
`;

export default function CmmnRadio(
    {
        dataArray,
        defaultVal,
        tagName,
        onSelectChange,
        className
    }
) {
    const [radioValue, setRadioValue] = useState(defaultVal);

    useEffect(() => {
        setRadioValue(defaultVal);
    }, [defaultVal]);

    const handleRadioClick = (e) => {
        const value = e.target.value;
        setRadioValue(value);
    }

    const handleRadioChange = (e) => {
        const target = { name: tagName, value: e.target.value };
        const event = { target: target }
        onSelectChange(event);
    };

    return (
        <RadioBtnWrap className={className}>
            {dataArray.map((val) => (
                <li key={val.value}>
                    <input
                        type="radio"
                        name={tagName}
                        value={val.value}
                        id={val.value}
                        checked={radioValue === val.value}
                        onChange={(e) => { handleRadioClick(e); handleRadioChange(e); }}
                    />
                    <label htmlFor={val.value}>{val.key}</label>
                </li>
            ))}
        </RadioBtnWrap>
    );
}

